import React, { useState, useEffect, memo } from "react";
import PropTypes from "prop-types";

// Context
import { useQuickCatchup } from "context/QuickCatchupContext";

// Components
import QuickCatchupModal from "components/QuickCatchupModal";
import useEntityName from "hooks/useEntityName"; // Import the new hook

const QuickCatchup = memo(function QuickCatchup({ source, competitorId, pressId }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { setCatchup, clearCatchup } = useQuickCatchup();

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const entityId = source === "news" ? pressId : competitorId;
  
  // Map the QuickCatchup source to the entity type expected by the hook
  const entityNameSource = (source === "products" || source === "digital-presence") ? "competitor" : "news";
  const entityName = useEntityName(entityNameSource, entityId);


  // Register the catchup action with the global context
  useEffect(() => {
    let hasRequiredId;

    if (source === 'news') {
      // The button should always be shown for news, as the backend
      // can handle a null `pressId` for "All Presses".
      hasRequiredId = true;
    } else {
      // For other sources, a valid entity ID is required.
      hasRequiredId = typeof entityId === 'string' && entityId.length > 0;
    }

    if (hasRequiredId) {
      setCatchup({
        action: handleOpenModal,
      });
    } else {
      clearCatchup();
    }

    return () => clearCatchup();
  }, [entityId, source, setCatchup, clearCatchup]);

  return (
    <QuickCatchupModal
      isOpen={isModalOpen}
      onClose={handleCloseModal}
      reportType={source}
      entityId={entityId}
      entityName={entityName}
    />
  );
});

QuickCatchup.propTypes = {
  source: PropTypes.oneOf(["news", "products", "digital-presence"]).isRequired,
  competitorId: PropTypes.string,
  pressId: PropTypes.string,
};

QuickCatchup.defaultProps = {
  competitorId: null,
  pressId: null,
};

export default QuickCatchup; 